import React, { Component, createRef } from 'react';
import { connect } from "react-redux";
import Grid from '../../../components/grid';
import { distributionComparisonReport, payrollDetailAction } from '../../../store/actions';
import orderBy from "lodash/orderBy";
import './style.scss';
import Select from 'react-select';
import { format, subDays } from 'date-fns';
import { noop } from 'lodash';
class PayrollComparisonView extends Component {
    constructor(props) {
        super(props);
    }
    columnDefs = [{
        headerName: "Employee information",
        children: [
            {
                headerName: "Employee Id",
                field: "employeeId"
            }, {
                headerName: "Employee Last Name",
                field: "empLastName",
            }, {
                headerName: "Employee First Name",
                field: "empFirstName"
            },
            {
                headerName: "Employee Status",
                field: "empStatus"
            },
            {
                headerName: "Pay Type",
                field: 'payType'
            }
        ]
    },
    {
        headerName: "Distribution information",
        children: [
            {
                headerName: "Distribution Code",
                field: "distCode"
            }, {
                headerName: "Job Code",
                field: "jobCode",
            }
        ]
    }];
    state = {
        loading: false,
        firstSelectOptions: [],
        selectedFirstPayroll: {},
        secondSelectOptions: [],
        selectedSecondPayroll: {},
        selectedStartWeek: "",
        selectedEndWeek: "",
        firstPayrollId: "",
        secondPayrollId: "",
        rowData: null,
        columnDefs: []
    };

    getLastPayrolls = async () => {
        await this.props.payrollDetailAction(this.props.UserReducer.company, {
            includeUnfinalized: true,
            payrollType: "Regular",
            addNumberDays: 14
        });
    };

    async componentDidMount() {
        this.setState({
            loading: true,
            columnDefs: this.columnDefs
        });
        await this.getLastPayrolls();
        this.setSelectOptions(this.props.PayrollReducer, this.submit);
    };

    submit = async () => {
        this.setColumns();
        await this.getData();
    };

    getData = async () => {
        await this.props.distributionComparisonReport({
            company: this.props.UserReducer.company,
            firstPayrollId: this.state.firstPayrollId,
            secondPayrollId: this.state.secondPayrollId
        });
        this.setState({ rowData: this.props.DISTRIBUTION_COMPARISON_REPORT || [], loading: false });

    };

    onGridReady = params => {
        this.gridApi = params.api;
    };

    formatCurrency = number => {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number || 0)
    };

    formatNumber = number => {
        if (number === undefined || number === null) return '0.00';
        return number.toFixed(2);
    };

    setColumns = () => {
        this.setState({ loading: true }, () => {
            this.gridApi.showLoadingOverlay();
        });
        let { selectedStartWeek, selectedEndWeek, firstPayDate, secondPayDate } = this.state;
        firstPayDate = format(new Date(firstPayDate), "MM/dd/yyyy");
        secondPayDate = format(new Date(secondPayDate), "MM/dd/yyyy");
        let dynamicColumns = [
            {
                headerName: selectedStartWeek,
                children: [
                    {
                        headerName: 'Earning',
                        field: `${firstPayDate}.earningAmount`,
                        valueFormatter: param => this.formatCurrency(param.value),
                        useValueFormatterForExport: false
                    },
                    {
                        headerName: 'Hours',
                        field: `${firstPayDate}.hours`,
                        valueFormatter: param => this.formatNumber(param.value),
                        useValueFormatterForExport: false
                    }
                ]
            }, {
                headerName: selectedEndWeek,
                children: [
                    {
                        headerName: 'Earning',
                        field: `${secondPayDate}.earningAmount`,
                        valueFormatter: param => this.formatCurrency(param.value),
                        useValueFormatterForExport: false
                    },
                    {
                        headerName: 'Hours',
                        field: `${secondPayDate}.hours`,
                        valueFormatter: param => this.formatNumber(param.value),
                        useValueFormatterForExport: false
                    }
                ]
            },
            {
                headerName: "Current To Previous Comparison",
                children: [
                    {
                        headerName: "Pay Diff",
                        field: 'c2pPayDiff',
                        valueFormatter: param => this.formatCurrency(param.value),
                        useValueFormatterForExport: false
                    },
                    {
                        headerName: 'Hours Diff',
                        field: 'c2pHourDiff',
                        valueFormatter: param => this.formatNumber(param.value),
                        useValueFormatterForExport: false
                    }
                ]
            },
            {
                headerName: 'Base Compensation',
                children: [
                    {
                        headerName: 'Pay Period Hours',
                        field: 'payPeriodHours',
                        valueFormatter: param => this.formatNumber(param.value),
                        useValueFormatterForExport: false
                    },
                    {
                        headerName: 'Pay Period Pay',
                        field: 'payPeriodPay',
                        valueFormatter: param => this.formatCurrency(param.value),
                        useValueFormatterForExport: false
                    }
                ]
            },
            {
                headerName: 'Base to Current Comparison',
                children: [
                    {
                        headerName: "Pay Diff",
                        field: "b2cPayDiff",
                        valueFormatter: param => this.formatCurrency(param.value),
                        useValueFormatterForExport: false
                    },
                    {
                        headerName: "Hours Diff",
                        field: "b2cHourDiff",
                        valueFormatter: param => this.formatNumber(param.value),
                        useValueFormatterForExport: false
                    }
                ]
            }
        ];
        this.setState({ columnDefs: [...this.columnDefs, ...dynamicColumns] });
    };

    handleStartWeekChanges = selected => {
        this.setState({
            selectedStartWeek: selected.label,
            firstPayrollId: selected.value,
            selectedFirstPayroll: selected,
            firstPayDate: selected.payDate
        });
        this.setSecondOptions(selected);
    };

    handlePreviousWeekChanges = selected => {
        let secondPayrollId = selected.value
        this.setState({
            selectedEndWeek: selected.label,
            secondPayrollId,
            selectedSecondPayroll: selected,
            secondPayDate: selected.payDate
        });
    };

    setSelectOptions = (payrollsList, callback) => {

        let firstSelectOptions = orderBy(payrollsList.filter(prl => {
            return (prl.payrollName.startsWith("Admin Bi-Weekly") || prl.payrollName.startsWith("Bi-Weekly")) && prl.payPeriodEnd;
        }).map(prl => {
            let { payrollName, payrollSystemId, payDate } = prl;
            let datePayDate = new Date(payDate);
            let utcPayDate = new Date(datePayDate.getUTCFullYear(), datePayDate.getUTCMonth(), datePayDate.getUTCDate());
            return {
                label: payrollName,
                value: payrollSystemId,
                payDate: utcPayDate.toLocaleDateString()
            }
        }),
            elem => Date.parse(elem.payDate), "desc")
        let selectedFirstPayroll = firstSelectOptions[0] || {};
        let { label, value, payDate } = selectedFirstPayroll;

        this.setState({
            firstSelectOptions,
            selectedFirstPayroll,
            firstPayrollId: value,
            selectedStartWeek: label,
            firstPayDate: payDate
        }, () => {
            this.setSecondOptions(selectedFirstPayroll, callback);
        });

    }

    setSecondOptions = (selectedFirstPayroll, callback) => {
        let firstIndex = this.state.firstSelectOptions.findIndex(op => op.value === selectedFirstPayroll.value);
        let secondSelectOptions = this.state.firstSelectOptions.map((el, idx) => ({ ...el, isDisabled: idx <= firstIndex }));
        let selectedSecondPayroll = {}, selectedEndWeek, secondPayrollId, secondPayDate;
        if (firstIndex < (secondSelectOptions.length - 1)) {
            selectedSecondPayroll = secondSelectOptions[firstIndex + 1];
            let { label, value, payDate } = selectedSecondPayroll;
            selectedEndWeek = label;
            secondPayrollId = value;
            secondPayDate = payDate
        };
        this.setState({
            secondSelectOptions,
            selectedSecondPayroll,
            selectedEndWeek,
            secondPayrollId,
            secondPayDate
        }, callback || noop);
    };

    render() {

        const { loading, firstSelectOptions, secondSelectOptions, selectedFirstPayroll, selectedSecondPayroll } = this.state;

        return (
            <>
                <div className="shadow_white_box full-box mt-0">
                    <div className="filter-list d-flex align-items-center justify-content-between table-header patient_hours">
                        <div className="filter-field d-flex align-items-center justify-content-between">
                            <label>Current Week</label>
                            <Select className="reactSelect"
                                onChange={(e) => this.handleStartWeekChanges(e)}
                                value={selectedFirstPayroll}
                                options={firstSelectOptions}
                            >

                            </Select>
                            <div className="filter-field d-flex">
                                <label>Compare to week</label>
                                <Select className="reactSelect"
                                    onChange={(e) => this.handlePreviousWeekChanges(e)}
                                    options={secondSelectOptions}
                                    value={selectedSecondPayroll}
                                >
                                </Select>
                            </div>
                        </div>
                        <button className="mla fs12 primary mini" onClick={this.submit} disabled={loading}>
                            {loading ? <span>Loading data </span> : <span>Run</span>}
                        </button>
                    </div>
                    <Grid
                        columnDefs={this.state.columnDefs}
                        rowData={this.state.rowData}
                        height='600px'
                        onGridReady={this.onGridReady}
                    >
                    </Grid>

                </div>
            </>
        )
    }
}
const mapStateToProps = ({ UserReducer, PayrollComparisonsReducer, PayrollReducer }) => {
    const { DISTRIBUTION_COMPARISON_REPORT } = PayrollComparisonsReducer;
    return { UserReducer, DISTRIBUTION_COMPARISON_REPORT, PayrollReducer }
};

export default connect(mapStateToProps, {
    distributionComparisonReport,
    payrollDetailAction
})(PayrollComparisonView);
